import { userProfileByChatIdSelector } from '../../selectors/userProfile';
import { getUserProfile } from '../../services/getUserProfile';
import { setUserProfilePending, setUserProfileLoaded } from '../../slices/userProfileSlice';
import { ERequestApiStatus } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';

export const fetchUserProfileThunk =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();
    const cachedProfile = userProfileByChatIdSelector(state, chatId);

    // Успешный статус означает, что данные реально пришли: пустой ответ маппер
    // помечает как Empty, поэтому такой профиль будет перезапрошен, а не закеширован.
    if (cachedProfile?.status === ERequestApiStatus.Succeed) {
      return;
    }

    dispatch(setUserProfilePending({ chatId }));

    const profile = await getUserProfile({ httpApi, logger, chatId });

    dispatch(setUserProfileLoaded({ chatId, ...profile }));
  };
